import { useState, useEffect } from 'react';

function useDebouncedSearch<T>(value: T, delay: number): [T, boolean] {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const [isDebouncing, setIsDebouncing] = useState(false);

    useEffect(() => {
        setIsDebouncing(true); // Set to true when the value changes

        const handler = setTimeout(() => {
            setDebouncedValue(value); // Update the debounced value
            setIsDebouncing(false); // Set to false after the debounce timeout
        }, delay);

        return () => clearTimeout(handler); // Cleanup the timeout on value or delay change
    }, [value, delay]);

    return [debouncedValue, isDebouncing];
}

export default useDebouncedSearch;
